export const GOOGLE_AUTH_URL = 'https://accounts.google.com/o/oauth2/auth';